import { numberColumn } from './number'
export const columnsTypes = {
  numberColumn
}
